import { motion } from "framer-motion";
import { useT } from "@/i18n";

const WA = "https://wa.me/393803758249?text=";

export const WhatsAppButton = () => {
  const t = useT();
  return (
  <motion.a
    href={WA + encodeURIComponent(t("wa.msg", "Buongiorno Emma Industrie, vorrei informazioni su un progetto."))}
    target="_blank"
    rel="noreferrer"
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 2, type: "spring", stiffness: 260, damping: 18 }}
    whileHover={{ scale: 1.08 }}
    whileTap={{ scale: 0.95 }}
    className="group fixed bottom-20 right-4 z-[70] flex items-center gap-3 rounded-full bg-[#25D366] p-3.5 text-white shadow-2xl sm:right-6"
    aria-label={t("wa.aria", "Scrivici su WhatsApp")}
    data-testid="whatsapp-button"
  >
    <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[#25D366] opacity-30" />
    <svg viewBox="0 0 32 32" className="h-7 w-7 fill-current" aria-hidden="true">
      <path d="M16.04 3C8.86 3 3.03 8.82 3.03 16c0 2.29.6 4.53 1.74 6.5L3 29l6.68-1.74A12.95 12.95 0 0 0 16.04 29C23.2 29 29 23.18 29 16S23.2 3 16.04 3Zm0 23.6c-1.97 0-3.9-.53-5.58-1.53l-.4-.24-3.96 1.04 1.06-3.86-.26-.4A10.56 10.56 0 0 1 5.4 16c0-5.86 4.77-10.62 10.64-10.62 5.86 0 10.6 4.76 10.6 10.62 0 5.87-4.75 10.6-10.6 10.6Zm5.82-7.94c-.32-.16-1.88-.93-2.17-1.03-.3-.11-.5-.16-.72.16-.21.32-.82 1.03-1 1.24-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.59-.95-.85-1.59-1.9-1.78-2.21-.18-.32-.02-.5.14-.65.15-.15.32-.37.48-.56.16-.18.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.53-.72-.54h-.61c-.21 0-.56.08-.85.4-.3.32-1.12 1.09-1.12 2.66s1.15 3.09 1.3 3.3c.17.21 2.26 3.45 5.47 4.84.77.33 1.36.53 1.83.68.77.24 1.47.2 2.02.12.62-.09 1.88-.77 2.15-1.51.27-.75.27-1.38.19-1.52-.08-.13-.29-.21-.61-.37Z" />
    </svg>
    <span className="hidden max-w-0 overflow-hidden whitespace-nowrap font-mono text-xs uppercase tracking-[0.15em] transition-[max-width] duration-500 group-hover:max-w-[160px] sm:inline">{t("wa.label", "Scrivici")}</span>
  </motion.a>
  );
};
